import { Route } from '@angular/router';

import { AuthLayout } from '@layouts/auth/auth.layout';
import { guestGuard } from '@guards/guest.guard';

export const routes: Route[] = [
  {
    path: 'auth',
    component: AuthLayout,
    canActivate: [guestGuard],
    canActivateChild: [guestGuard],
    children: [
      { path: '', redirectTo: 'login', pathMatch: 'full' },
      {
        path: 'login',
        loadComponent: () =>
          import('@components/pages/auth/login/login.component').then((m) => m.LoginComponent),
        title: 'Sign in',
      },
      {
        path: 'forgot-password',
        loadComponent: () =>
          import('@components/pages/auth/forgot-password/forgot-password.component').then(
            (m) => m.ForgotPasswordComponent,
          ),
        title: 'Forgot password',
      },
      {
        path: 'reset-password',
        loadComponent: () =>
          import('@components/pages/auth/reset-password/reset-password.component').then(
            (m) => m.ResetPasswordComponent,
          ),
        title: 'Reset password',
      },
    ],
  },
];
